<script>
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import {useSecurityStore} from "@/stores/Security";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const {backgroundColor} = useSharedData();
        const {loading, configurations, findAll, save} = useConfiguration();
        
        const securityStore = useSecurityStore();
        
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            loading,
            backgroundColor,
            configurations,
            save,
        }
    }
};
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_TRAINING_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('common.general') }}</v-tab>
                <v-tab>{{ $t('common.email') }}</v-tab>
                
                
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('training.other_catalog_validation_step') }}</strong>
                                <str-step-select
                                    v-model="configurations[101].strr"
                                    module="TRAINING_REQUEST"
                                    by-name
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_object') }}</strong>
                                <w-text-field
                                    v-model="configurations[111].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_body') }}</strong>
                                <w-simple-text-area
                                    v-model="configurations[112].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                
                <!--<v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_object') }}</strong>
                                <w-text-field
                                    v-model="configurations[104].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <strong>{{ $t('common.email_body') }}</strong>
                                <w-simple-text-area
                                    v-model="configurations[105].strr"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>-->
            </v-tabs>
        </template>
    </w-app>
</template>